import { PropsWithChildren, ReactNode } from 'react'
import cx from 'classnames'

import './style.scss'

export type SettingItem = {
  label: string
  sub?: ReactNode
  noBorder?: boolean
  danger?: boolean
}

export const SettingItem = ({
  children,
  label,
  sub,
  noBorder,
  danger,
}: PropsWithChildren<SettingItem>) => (
  <div
    className={cx('SettingItem', {
      'SettingItem--no-border': noBorder,
      'SettingItem--danger': danger,
    })}
  >
    <div className="SettingItem__wrapper">
      <p>{label}</p>

      {children}
    </div>

    {sub && <p className="SettingItem__sub">{sub}</p>}
  </div>
)
